import { FC, useState, useEffect } from 'react';
import ja from 'date-fns/locale/ja';
import dayjs from 'dayjs';
import { registerLocale } from 'react-datepicker';
import changeDeliveryDateModalClass from '../../assets/scss/ChangeDeliveryDateModal/ChangeDeliveryDateModal.module.scss';
import { ChangeDeliveryDateModalViewType } from '../../types/view/ChangeDeliveryDateModalViewType';
import { CommonModal } from '../CommonModal';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { postMessageGtag } from '../../utils/trackClick';
import { ChangeDeliveryDate } from './ChangeDeliveryDateModalItem/ChangeDeliveryDate';
import { ChangeDeliveryTime } from './ChangeDeliveryDateModalItem/ChangeDeliveryTime';

registerLocale('ja', ja);
dayjs.locale('ja');

export const ChangeDeliveryDateModal: FC<{
  active: boolean;
  closeFunc: () => void;
  changeDeliveryDateModal: ChangeDeliveryDateModalViewType | null;
  isDeliveryTimeSetting?: boolean;
  loading: boolean;
  route: string;
  changeDeliveryDateFunc: (date: Date) => void;
  changeDeliveryTimeFunc: (deliveryTime: string) => void;
  clickUpdateBtnFunc: () => void;
}> = ({
  active,
  closeFunc,
  changeDeliveryDateModal,
  isDeliveryTimeSetting = false,
  loading,
  route,
  changeDeliveryDateFunc,
  changeDeliveryTimeFunc,
  clickUpdateBtnFunc,
}) => {
  const [initialDate, setInitialDate] = useState<{ date: string; time: string } | null>(null);

  const [isUpdateDate, setIsUpdateDate] = useState(false);

  useEffect(() => {
    if (active) {
      if (!changeDeliveryDateModal || initialDate) return;
      setInitialDate({
        date: dayjs(changeDeliveryDateModal.nextDeliveryDate).format('YYYY/MM/DD'),
        time: changeDeliveryDateModal.deliveryTime,
      });
    } else {
      setInitialDate(null);
    }
  }, [active, changeDeliveryDateModal, initialDate]);

  useEffect(() => {
    if (changeDeliveryDateModal && initialDate) {
      const updateDate = dayjs(changeDeliveryDateModal.nextDeliveryDate).format('YYYY/MM/DD');
      const updateTime = changeDeliveryDateModal.deliveryTime;
      if (updateDate !== initialDate.date || updateTime !== initialDate.time) {
        setIsUpdateDate(true);
      } else {
        setIsUpdateDate(false);
      }
    } else {
      setIsUpdateDate(false);
    }
  }, [changeDeliveryDateModal, initialDate]);

  if (!changeDeliveryDateModal) return <></>;

  // GAタグ
  let eventCategory: string;
  let eventName_pullDownDateBtn: string;
  let eventName_pullDownTimeBtn: string;
  let eventName_changeDateBtn: string;
  let eventName_closeBtn: string;
  let eventName_closeOutsideBtn: string;
  if (route === 'CancellationCushion') {
    eventCategory = 'preventCancel';
    eventName_pullDownDateBtn = 'click_CancelPage_date_change';
    eventName_pullDownTimeBtn = '';
    eventName_changeDateBtn = 'click_CancelPage_date';
    eventName_closeBtn = 'click_CancelPage_modal_close_date_cancel';
    eventName_closeOutsideBtn = 'click_CancelPage_modal_close_date';
  } else {
    const suffix = isDeliveryTimeSetting ? 'pack' : 'packet';
    eventCategory = 'detailCalender';
    eventName_pullDownDateBtn = 'click_date_change_' + suffix;
    eventName_pullDownTimeBtn = 'click_time_change_' + suffix;
    eventName_changeDateBtn = 'click_date_' + suffix;
    eventName_closeBtn = 'click_modal_close_date_cancel_' + suffix;
    eventName_closeOutsideBtn = 'click_modal_close_date_' + suffix;
  }

  const content = (
    <>
      <div className={changeDeliveryDateModalClass.container}>
        <div className={changeDeliveryDateModalClass.title}>
          {isDeliveryTimeSetting ? 'お届け日・時間の変更' : 'お届け日の変更'}
        </div>
        <div className={changeDeliveryDateModalClass.deliveryContainer}>
          <ChangeDeliveryDate
            changeDeliveryDateModal={changeDeliveryDateModal}
            changeDeliveryDateFunc={changeDeliveryDateFunc}
            clickPullDownEventFunc={() => {
              postMessageGtag(eventName_pullDownDateBtn, eventCategory);
            }}
          />
          {isDeliveryTimeSetting && (
            <ChangeDeliveryTime
              changeDeliveryDateModal={changeDeliveryDateModal}
              changeDeliveryTimeFunc={changeDeliveryTimeFunc}
              clickPullDownEventFunc={() => {
                postMessageGtag(eventName_pullDownTimeBtn, eventCategory);
              }}
            />
          )}
        </div>
        <div
          className={commonModalClass.btnContainer}
          style={{ marginTop: '40px' }}
        >
          <button
            className={`${commonModalClass.btnPrimary} ${commonModalClass.grayOutDisabled}`}
            style={{ fontSize: '14px', height: '32px' }}
            onClick={() => {
              postMessageGtag(eventName_changeDateBtn, eventCategory);
              clickUpdateBtnFunc();
            }}
            disabled={loading || !isUpdateDate}
          >
            変更を完了する
          </button>
          <button
            className={commonModalClass.btnLink}
            style={{ fontSize: '14px' }}
            onClick={() => {
              closeFunc();
              postMessageGtag(eventName_closeBtn, eventCategory);
              window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={() => {
        closeFunc();
        postMessageGtag(eventName_closeOutsideBtn, eventCategory);
      }}
      loading={loading}
    >
      {content}
    </CommonModal>
  );
};
